export default {
  csrfToken: null,
  expiresAt: null,
  home: { name: 'auth.login' },
  scopes: [],
  user: {},
}
